import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section
      className="intro_section p-100"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#259354" }}>Highlights</span>
            </h2>
            <p>
              The unparalleled user experience and the extraordinary
              functionality are two major highlights of Mart Book app. Users can
              view upcoming lots, generate reports, go through their booking
              history, get live notifications and make descriptions as detailed
              as they’d like.
            </p>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-xl-1 offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/martbook/highlights_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1284}
              height={866}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
